/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
import type { MinimalWhoAmITherapist } from './MinimalWhoAmITherapist';
export type WhoAmIClient = {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    gender: WhoAmIClient.gender;
    phoneNumber: string | null;
    birthdate: string | null;
    isActive: boolean;
    therapists: Array<MinimalWhoAmITherapist>;
    address: Address | null;
};
export namespace WhoAmIClient {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

